import { Order, CustomerOrder, SellerOrder } from "../types/Order";

export const mapOrderStatus = (status: string): CustomerOrder["status"] => {
  const result: CustomerOrder["status"] = (() => {
    switch (status) {
      case "NEW":
        return "New";
      case "ORDER_APPROVED":
        return "Order Approved";
      case "PROCESSING":
        return "Processing";
      case "READY_FOR_DISPATCH":
        return "Ready for Dispatch";
      case "DISPATCHED":
        return "Dispatched";
      case "DELIVERED":
        return "Delivered";
      case "CANCELLED":
        return "Cancelled";
      default:
        throw new Error(`Unexpected order status: ${status}`);
    }
  })();
  return result;
};

export const mapPaymentStatus = (status: string): CustomerOrder["payment"] => {
  switch (status) {
    case "SUCCESS":
      return "Complete";
    case "PENDING":
      return "Pending";
    case "FAILED":
      return "Failed";
    default:
      throw new Error(`Unexpected payment status: ${status}`);
  }
};

// Main transformation function
export const transformToCustomerOrders = (
  backendOrders: Order[]
): CustomerOrder[] => {
  return backendOrders.map((backendOrder) => ({
    date: backendOrder.createdDate,
    orderID: backendOrder.id,
    payment: mapPaymentStatus(backendOrder.paymentStatus),
    status: mapOrderStatus(backendOrder.orderStatus),
  }));
};

export const transformToSellerOrders = (
  backendOrders: Order[]
): SellerOrder[] => {
  return backendOrders.map((backendOrder) => ({
    id: backendOrder.id,
    customerId: backendOrder.customer?.id,
    customerName: backendOrder.customer?.outletName || "Unknown Customer",
    location:
      backendOrder.customer?.Address?.registeredAddress ||
      backendOrder.customer?.Address?.licenseAddress ||
      "Unknown Location",
    orderedDate: backendOrder.createdDate,
    orderDetails: {
      orderId: backendOrder.id,
      price: backendOrder.totalAmountInCents
        ? parseInt(backendOrder.totalAmountInCents, 10) / 100
        : 0, // Fallback to 0 if totalAmountInCents is invalid
    },
    paymentStatus: mapPaymentStatus(backendOrder.paymentStatus),
    orderStatus: mapOrderStatus(backendOrder.orderStatus),
    grandTotal: backendOrder.grandTotal,
  }));
};
